module.exports = "/_next/static/images/avatar-frame-tier-0-d4a2cc0c28fe02609605326a9d3a7435.png";